import React, { Component } from 'react';
import styled from 'styled-components';
import { ErrorMessage } from './styles';

export const ModalInputBox = styled.div`
  position: relative;
  min-height: 80px;

  label {
    display: block;
    width: 100%;
  }

  input {
    padding: 10px;
    width: 100%;
    border: 1px solid #ccc;
    transition: box-shadow 0.2s ease;
    line-height: 1.3;

    &:focus {
      box-shadow: 0 0 8px rgba(102, 175, 233, 0.6);
    }

    &:disabled {
      cursor: not-allowed;
    }
  }

  .labelSpan {
    display: block;
    margin-bottom: 5px;
    font-size: 14px;
    cursor: pointer;
  }
`;

class Input extends Component {
  render() {
    const { input, meta, label, ...props } = this.props;

    return (
      <ModalInputBox>
        <label>
          <span className="labelSpan">{label}</span>
          <input type={props.type ? props.type : 'text'} {...input} {...props} />
        </label>

        {meta.touched && meta.error && (
          <ErrorMessage show={meta.touched && meta.error}>{meta.error}</ErrorMessage>
        )}
      </ModalInputBox>
    );
  }
}

export default Input;
